const createWidgetTemplateFactory = require('components-framework/widget/create_widget_template_factory');

module.exports = createWidgetTemplateFactory({
    name: 'section_details',
    viewClass: require('./view'),
    templates: {
        horizontal: require('components/flights/section_details/templates/desktop/horizontal.html'),
        airportInfo: require('components/flights/section_details/templates/desktop/airport_info.html'),
        flightInfo: require('components/flights/section_details/templates/desktop/flight_info.html'),
        locationInfo: require('components/flights/section_details/templates/desktop/location_info.html'),
        sectionDateTime: require('components/flights/section_details/templates/desktop/section_date_time.html'),
        vertical: require('components/flights/section_details/templates/desktop/vertical.html'),
    },
});
